import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';
import CalendarioExamenes from './CalendarioExamenes';

const Home = () => {
  return (
    <div className="home-container">
      <section className="hero-section">
        <h1 className="hero-title">
          Vortex EXANI-II
        </h1>
        <p className="hero-subtitle">
          Plataforma integral de preparación para el examen Ceneval EXANI-II, utilizado por universidades públicas, autónomas e instituciones de educación superior en México 2027.
        </p>
      </section>

      {/* Calendario Oficial de Fechas y Convocatorias */}
      <CalendarioExamenes />

      <section className="exam-info-section">
        <div className="exam-info-header">
          <h2>Examen EXANI-II · CENEVAL</h2>
          <p>Información oficial del examen nacional con el que se evalúa tu ingreso a la Educación Superior.</p>
        </div>

        <div className="exam-stats">
          <div className="stat-card">
            <span className="stat-value">168</span>
            <span className="stat-label">reactivos totales</span>
            <span className="stat-note">en una sola sesión</span>
          </div>
          <div className="stat-card">
            <span className="stat-value">138</span>
            <span className="stat-label">forman el puntaje global</span>
            <span className="stat-note">las áreas transversales + módulo</span>
          </div>
          <div className="stat-card">
            <span className="stat-value">4.5 h</span>
            <span className="stat-label">duración máxima</span>
            <span className="stat-note">sin receso intermedio</span>
          </div>
          <div className="stat-card">
            <span className="stat-value">A · B · C</span>
            <span className="stat-label">opciones por reactivo</span>
            <span className="stat-note">solo una correcta, sin penalización</span>
          </div>
        </div>

        <div className="exam-areas">
          <div className="card exam-areas-card">
            <h3>Áreas que componen el puntaje global</h3>
            <ul>
              <li><strong>Comprensión lectora</strong> <span>30 reactivos</span></li>
              <li><strong>Redacción indirecta</strong> <span>30 reactivos</span></li>
              <li><strong>Pensamiento matemático</strong> <span>30 reactivos</span></li>
              <li><strong>Módulo disciplinar</strong> <span>24–48 reactivos*</span></li>
            </ul>
            <p className="exam-disclaimer">
              * El módulo disciplinar lo elige la institución educativa (p. ej. 24 reactivos por módulo).
              Además, el examen incluye <strong>Inglés como lengua extranjera</strong> (30 reactivos) a modo
              de <strong>diagnóstico</strong>: no se considera en el puntaje global.
            </p>
          </div>
        </div>

        <div className="exam-cta">
          <Link to="/dashboard/documentos-ceneval" className="btn-primary exam-cta-btn">
            📜 Ver guías y folletos oficiales
          </Link>
        </div>
      </section>

      <section className="features-section">
        <div className="features-grid">
          {/* Flashcards */}
          <div className="card feature-card" style={{ borderTop: '3px solid #c5a059' }}>
            <div className="feature-icon">📇</div>
            <h3>Flashcards</h3>
            <p>Tarjetas de memoria con repetición espaciada y autoevaluación inteligente.</p>
            <Link to="/dashboard/flashcards" className="btn-primary feature-btn">Práctica Memoria</Link>
          </div>

          {/* Mapa de Debilidades */}
          <div className="card feature-card" style={{ borderTop: '3px solid #ef4444' }}>
            <div className="feature-icon">📊</div>
            <h3>Mapa de Debilidades</h3>
            <p>Diagnóstico visual por ley y materia con semáforo 🔴🟡🟢 para enfoque de estudio.</p>
            <Link to="/dashboard/mapa-debilidades" className="btn-primary feature-btn">Ver Semáforo</Link>
          </div>

          {/* Modo Guardia */}
          <div className="card feature-card" style={{ borderTop: '3px solid #c5a059' }}>
            <div className="feature-icon">🛡️</div>
            <h3>Modo Audio</h3>
            <p>Estudio auditivo pasivo continuo: Pregunta ➔ Pausa de reflexión ➔ Respuesta.</p>
            <Link to="/dashboard/modo-guardia" className="btn-primary feature-btn">Iniciar Guardia</Link>
          </div>

          {/* Cuestionarios */}
          <div className="card feature-card">
            <div className="feature-icon">📝</div>
            <h3>Cuestionarios</h3>
            <p>Evaluación interactiva de conocimientos con retroalimentación en tiempo real.</p>
            <Link to="/dashboard/quiz" className="btn-primary feature-btn">Explorar</Link>
          </div>

          {/* IA Vortex */}
          <div className="card feature-card">
            <div className="feature-icon">🤖</div>
            <h3>IA Vortex</h3>
            <p>Análisis de documentos y generación de resúmenes mediante inteligencia artificial.</p>
            <Link to="/dashboard/ia-vortex" className="btn-primary feature-btn">Consultar</Link>
          </div>

          {/* Repositorio de Audio */}
          <div className="card feature-card">
            <div className="feature-icon">🎧</div>
            <h3>Repositorio de Audio</h3>
            <p>Audios estratégicos y bibliografía narrada para estudio en movimiento.</p>
            <Link to="/dashboard/audios" className="btn-primary feature-btn">Escuchar</Link>
          </div>

          {/* Simulador */}
          <div className="card feature-card">
            <div className="feature-icon">🎯</div>
            <h3>Simulador</h3>
            <p>Entorno de evaluación real con cronómetro y ranking de desempeño.</p>
            <Link to="/dashboard/simulador" className="btn-primary feature-btn">Iniciar Test</Link>
          </div>
        </div>
      </section>

      <section className="info-section">
        <div className="card">
          <h2>Sobre Proyecto Vortex</h2>
          <p style={{ textAlign: 'justify', lineHeight: '1.8' }}>
            Vortex EXANI-II, representa el siguiente paso estratégico en la formación educativa.
            Integrando modelos de lenguaje avanzados y herramientas de accesibilidad, permitimos que los alumnos
            puedan optimizar sus ciclos de estudio, realizar prácticas de sus modulos y un simulador real de examen para afianzar sus conocimientos. Además, el proyecto incluye un repositorio de audios narrados y resúmenes de los temas más relevantes, ofreciendo
            experiencias auditivas de alta fidelidad.
          </p>
        </div>
      </section>

      <footer className="home-footer">
        <p>© {new Date().getFullYear()} VORTEX EXANI-II - Inteligencia Aplicada.</p>
      </footer>
    </div>
  );
};

export default Home;
